import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Input,
  Button
} from 'semantic-ui-react'

const CardImagingOrderInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardImagingOrderInterfaceUX-div-0"
        style={{position: "relative", width: "calc(-180px + 100vw)", height: "100%", padding: "10px"}}>
        <div
          className="ui form"
          id="CardImagingOrderInterfaceUX-div-1"
          style={{padding: "10px 10px 15px", marginBottom: "-10px"}}>
          
          <FormGroup
            id="CardImagingOrderInterfaceUX-FormGroup-5">
            <FormField
              className="noPadding --hard"
              id="CardImagingOrderInterfaceUX-FormField-8">
              <label
                id="CardImagingOrderInterfaceUX-label-12">
                HN
              </label>
              <Input
                id="CardImagingOrderInterfaceUX-Input-15"
                name="hn"
                onChange={props.onChangeData}
                value={props.searchImagingOrder?.hn || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardImagingOrderInterfaceUX-FormField-9"
              style={{marginLeft: "20px"}}>
              <label
                id="CardImagingOrderInterfaceUX-label-13">
                {"\u00A0"}
              </label>
              <div
                id="CardImagingOrderInterfaceUX-div-16">
                {props.searchButton}
              </div>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardImagingOrderInterfaceUX-FormField-10"
              style={{marginLeft: "20px"}}>
              <label
                id="CardImagingOrderInterfaceUX-label-14">
                {"\u00A0"}
              </label>
              <Button
                color="orange"
                id="CardImagingOrderInterfaceUX-Button-17"
                onClick={props.onClearFilter}>
                Clear
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardImagingOrderInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.imagingOrderInterfaceList}
            id="CardImagingOrderInterfaceUX-Table-4"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardImagingOrderInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardImagingOrderInterfaceUX-FormGroup-6"
            inline={true}
            style={{ display: "flex", justifyContent: "flex-end" }}>
            <FormField
              id="CardImagingOrderInterfaceUX-FormField-7">
              <div
                id="CardImagingOrderInterfaceUX-div-11">
                {props.triggerButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardImagingOrderInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Mon Apr 28 2025 09:07:06 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", width: \"calc(-180px + 100vw)\", height: \"100%\", padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.imagingOrderInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-Table-4"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormGroup-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 5,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormField-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 5,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 5,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-FormField-10"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.triggerButton"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Input",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-Input-15"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchImagingOrder?.hn || \"\""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardImagingOrderInterfaceUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 17,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardImagingOrderInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
